import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import { API_URL } from "../constants"

const initialState = {
  campaigns: [],
  campaign: null,
  loading: false,
  error: null,
  success: false,
  pagination: {
    total: 0,
    pages: 0,
    page: 1,
    limit: 10,
  },
  stats: {
    total: 0,
    pending: 0,
    processing: 0,
    finished: 0,
    rejected: 0,
    running: 0,
  },
}

// Create campaign
export const createCampaign = createAsyncThunk(
  "campaigns/createCampaign",
  async (campaignData, { rejectWithValue }) => {
    try {
      const token = JSON.parse(localStorage.getItem("userInfo")).token

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }

      const { data } = await axios.post(`${API_URL}/api/campaigns`, campaignData, config)
      return data
    } catch (error) {
      return rejectWithValue(
        error.response && error.response.data.message ? error.response.data.message : error.message,
      )
    }
  },
)

// Get admin campaigns
export const getAdminCampaigns = createAsyncThunk(
  "campaigns/getAdminCampaigns",
  async ({ status, page, limit, dateFilter, countryFilter,reportChnagedFilter}, { rejectWithValue }) => {
    try {
      const token = JSON.parse(localStorage.getItem("userInfo")).token

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }

      let url = `${API_URL}/api/campaigns/admin?status=${status || ""}&page=${page || 1}&limit=${limit || 10}`
      if (dateFilter) {
        url += `&dateFilter=${dateFilter}`
      }
      if (countryFilter) {
        url += `&countryFilter=${countryFilter}`
      }

      if( reportChnagedFilter) {
        url += `&reportChnagedFilter=${reportChnagedFilter}`
      }

      const { data } = await axios.get(url, config)
      return data
    } catch (error) {
      return rejectWithValue(
        error.response && error.response.data.message ? error.response.data.message : error.message,
      )
    }
  },
)

// Get user campaigns
export const getUserCampaigns = createAsyncThunk(
  "campaigns/getUserCampaigns",
  async ({ status, page, limit, dateFilter, userId, countryFilter } = {}, { rejectWithValue }) => {
    try {
      const token = JSON.parse(localStorage.getItem("userInfo")).token

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }

      let url = `${API_URL}/api/campaigns?status=${status || ""}&page=${page || 1}&limit=${limit || 10}`
      if (dateFilter) {
        url += `&dateFilter=${dateFilter}`
      }
        url += `&countryFilter=${countryFilter}`
      
      if (userId) {
        url += `&userId=${userId}`
      }

      const { data } = await axios.get(url, config)
      return data
    } catch (error) {
      return rejectWithValue(
        error.response && error.response.data.message ? error.response.data.message : error.message,
      )
    }
  },
)

// Get campaign by ID
export const getCampaignById = createAsyncThunk("campaigns/getCampaignById", async (id, { rejectWithValue }) => {
  try {
    const token = JSON.parse(localStorage.getItem("userInfo")).token

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }

    const { data } = await axios.get(`${API_URL}/api/campaigns/${id}`, config)
    return data
  } catch (error) {
    return rejectWithValue(error.response && error.response.data.message ? error.response.data.message : error.message)
  }
})

// Update campaign status
export const updateCampaignStatus = createAsyncThunk(
  "campaigns/updateCampaignStatus",
  async ({ id, statusData }, { rejectWithValue }) => {
    try {
      const token = JSON.parse(localStorage.getItem("userInfo")).token

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }

      const { data } = await axios.put(`${API_URL}/api/campaigns/${id}/status`, statusData, config)
      return data
    } catch (error) {
      return rejectWithValue(
        error.response && error.response.data.message ? error.response.data.message : error.message,
      )
    }
  },
)

// Update batch campaign statuses
export const updateBatchCampaignStatus = createAsyncThunk(
  "campaigns/updateBatchCampaignStatus",
  async ({ campaignIds, statusData }, { rejectWithValue }) => {
    try {
      const token = JSON.parse(localStorage.getItem("userInfo")).token

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }

      const { data } = await axios.put(
        `${API_URL}/api/campaigns/batch-status`,
        {
          campaignIds,
          status: statusData.status,
          rejectionReason: statusData.rejectionReason,
        },
        config,
      )
      return data
    } catch (error) {
      return rejectWithValue(
        error.response && error.response.data.message ? error.response.data.message : error.message,
      )
    }
  },
)


export const getCampaignStats = createAsyncThunk(
  "campaigns/getCampaignStats",
  async ({ dateFilter } = {}, { rejectWithValue }) => {
    try {
      const userInfo = localStorage.getItem("userInfo")
      const token = userInfo ? JSON.parse(userInfo).token : null

      if (!token) throw new Error("No token found")

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }

      // Base URL
      let url = `${API_URL}/api/campaigns/stats`

      // Add query parameter correctly
      if (dateFilter) {
        url += `?dateFilter=${encodeURIComponent(dateFilter)}`
      }


      const { data } = await axios.get(url, config)
      return data
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message
      )
    }
  }
)


// Update campaign
export const updateCampaign = createAsyncThunk(
  "campaigns/updateCampaign",
  async ({ id, campaignData }, { rejectWithValue }) => {
    try {
      const token = JSON.parse(localStorage.getItem("userInfo")).token

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }

      const { data } = await axios.put(`${API_URL}/api/campaigns/${id}`, campaignData, config)
      return data
    } catch (error) {
      return rejectWithValue(
        error.response && error.response.data.message ? error.response.data.message : error.message,
      )
    }
  },
)

// Run campaign
export const runCampaign = createAsyncThunk("campaigns/runCampaign", async ({ id, serverId, runType, cuttingPercentage }, { rejectWithValue }) => {
  try {
    const token = JSON.parse(localStorage.getItem("userInfo")).token

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }

    const { data } = await axios.post(`${API_URL}/api/campaigns/${id}/run`, { serverId, runType, cuttingPercentage }, config)
    return data
  } catch (error) {
    return rejectWithValue(error.response && error.response.data.message ? error.response.data.message : error.message)
  }
})

// Compare campaigns
export const compareCampaigns = createAsyncThunk(
  "campaigns/compareCampaigns",
  async ({ currentCampaignId, previousCampaignIds }, { rejectWithValue }) => {
    try {
      const token = JSON.parse(localStorage.getItem("userInfo")).token

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }

      const { data } = await axios.post(
        `${API_URL}/api/campaigns/${currentCampaignId}/compare-campaigns`,
        { previousCampaignIds },
        config,
      )
      return data
    } catch (error) {
      return rejectWithValue(
        error.response && error.response.data.message ? error.response.data.message : error.message,
      )
    }
  },
)

// Skip comparison
export const skipComparison = createAsyncThunk("campaigns/skipComparison", async (campaignId, { rejectWithValue }) => {
  try {
    const token = JSON.parse(localStorage.getItem("userInfo")).token

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }

    const { data } = await axios.post(`${API_URL}/api/campaigns/${campaignId}/skip-comparison`, {}, config)
    return data
  } catch (error) {
    return rejectWithValue(error.response && error.response.data.message ? error.response.data.message : error.message)
  }
})

const campaignSlice = createSlice({
  name: "campaigns", // This is the key in the Redux store
  initialState,
  reducers: {
    resetCampaignState: (state) => {
      state.loading = false
      state.error = null
      state.success = false
    },
  },
  extraReducers: (builder) => {
    builder
      // Create campaign
      .addCase(createCampaign.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(createCampaign.fulfilled, (state, action) => {
        state.loading = false
        state.success = true
        state.campaign = action.payload.campaign
      })
      .addCase(createCampaign.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      // Get admin campaigns
      .addCase(getAdminCampaigns.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getAdminCampaigns.fulfilled, (state, action) => {
        state.loading = false
        state.campaigns = action.payload.campaigns
        state.pagination = action.payload.pagination
      })
      .addCase(getAdminCampaigns.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      // Get user campaigns
      .addCase(getUserCampaigns.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getUserCampaigns.fulfilled, (state, action) => {
        state.loading = false
        state.campaigns = action.payload.campaigns
        state.pagination = action.payload.pagination
      })
      .addCase(getUserCampaigns.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      // Get campaign by ID
      .addCase(getCampaignById.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getCampaignById.fulfilled, (state, action) => {
        state.loading = false
        state.campaign = action.payload.campaign
      })
      .addCase(getCampaignById.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      // Update campaign status
      .addCase(updateCampaignStatus.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(updateCampaignStatus.fulfilled, (state, action) => {
        state.loading = false
        state.success = true
        state.campaign = action.payload.campaign
      })
      .addCase(updateCampaignStatus.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      // Update batch campaign status
      .addCase(updateBatchCampaignStatus.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(updateBatchCampaignStatus.fulfilled, (state, action) => {
        state.loading = false
        state.success = true

        // Update campaigns in the state if they exist
        if (action.payload.results && action.payload.results.success) {
          action.payload.results.success.forEach((result) => {
            const index = state.campaigns.findIndex((c) => c._id === result.id)
            if (index !== -1) {
              state.campaigns[index] = result.campaign
            }
          })
        }
      })
      .addCase(updateBatchCampaignStatus.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      // Get campaign stats
      .addCase(getCampaignStats.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getCampaignStats.fulfilled, (state, action) => {
        state.loading = false
        state.stats = action.payload
      })
      .addCase(getCampaignStats.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      // Update campaign
      .addCase(updateCampaign.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(updateCampaign.fulfilled, (state, action) => {
        state.loading = false
        state.success = true
        state.campaign = action.payload.campaign
        // Update the campaign in the campaigns array
        state.campaigns = state.campaigns.map((campaign) =>
          campaign._id === action.payload.campaign._id ? action.payload.campaign : campaign,
        )
      })
      .addCase(updateCampaign.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      // Run campaign
      .addCase(runCampaign.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(runCampaign.fulfilled, (state, action) => {
        state.loading = false
        state.success = true
        state.campaign = action.payload.campaign

        // Update the campaign in the campaigns array
        const index = state.campaigns.findIndex((c) => c._id === action.payload.campaign._id)
        if (index !== -1) {
          state.campaigns[index] = action.payload.campaign
        }
      })
      .addCase(runCampaign.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      // Compare campaigns
      .addCase(compareCampaigns.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(compareCampaigns.fulfilled, (state, action) => {
        state.loading = false
        state.success = true
        state.campaign = action.payload.campaign // Update the current campaign with common numbers
      })
      .addCase(compareCampaigns.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      // Skip comparison
      .addCase(skipComparison.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(skipComparison.fulfilled, (state, action) => {
        state.loading = false
        state.success = true
        state.campaign = action.payload.campaign // Update the current campaign status
      })
      .addCase(skipComparison.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
  },
})

export const { resetCampaignState } = campaignSlice.actions

export default campaignSlice.reducer